// src/components/Alerts/AlertBadge.js
// Bell icon with badge showing alert count
// Clicking navigates to alerts section

import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { NotificationsActive as NotificationsActiveIcon, Notifications as NotificationsIcon } from '@mui/icons-material';

/**
 * AlertBadge - Bell icon with alert count badge
 * 
 * Props:
 * @param {number} count - Number of alerts
 * @param {function} onClick - Click handler
 * @param {string} color - Icon color (default: white for header)
 */
const AlertBadge = ({ count = 0, onClick, color = 'white' }) => {
    const hasAlerts = count > 0;
    
    return (
        <Tooltip title={hasAlerts ? `${count} client${count !== 1 ? 's' : ''} need attention` : 'No alerts'}>
            <IconButton
                onClick={onClick}
                sx={{
                    color: color,
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' }
                }}
            >
                <Badge 
                    badgeContent={count} 
                    color="error"
                    max={99}
                    sx={{
                        '& .MuiBadge-badge': {
                            bgcolor: hasAlerts ? 'error.main' : 'transparent',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '0.7rem'
                        }
                    }}
                >
                    {hasAlerts ? (
                        <NotificationsActiveIcon sx={{ animation: count > 0 ? 'pulse 2s infinite' : 'none' }} />
                    ) : (
                        <NotificationsIcon />
                    )}
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default AlertBadge;